// @material-ui/icons

import { ContactSupport } from '@mui/icons-material'
import { ContactPage } from 'Pages/ContactPage/ContactPage'

export function getHomeRoutes(client: any) {
  if (client.platformId === 1) {
    return [
      {
        path: '/contact',
        navBarHeading: 'Contact Us',
        name: 'Contact Us',
        icon: ContactSupport,
        mini: '',
        rtlMini: '',
        rtlName: 'تواصل معنا',
        component: ContactPage,
        layout: '/admin',
        sticky: true,
      },
    ]
  }
  return []
}
